<script>
  import MenuHeading from "../shared/MenuHeading.svelte";
  import axios from "axios";
  import config from "../stores/config";
  import * as ls from "local-storage";
  import t from "../utils/t";

  let username;
  let password;
  let loading = false;

  const handleLogin = () => {
    loading = true;

    axios
      .post(`${$config.backendURL}/login`, {
        username: username.trim(),
        password: password.trim(),
      })
      .then((res) => {
        loading = false;
        ls.set("jwt", res.data.token);
        if (res.data.error) {
          console.log(err);
          alert(res.data.error);
        } else {
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          window.location = "/#/orders";
        }
      })
      .catch((err) => {
        loading = false;
        console.log(err);
        alert(
          t({
            en: "The username or password entered was not correct!",
            fr: "Nom d'utilisateur ou mot de passe incorrect!",
          })
        );
        window.location = "/#/login";
      });
  };
</script>

<svelte:head>
  <title>Login | Fabi CC System</title>
</svelte:head>

<div
  class="tracking-wide font-normal h-screen w-full p-5"
  style="background-color: #f4f3f8"
>
  <div class="flex flex-col justify-center items-center">
    <div class="">
      <MenuHeading
        title={t({
          en: "FABI CC System",
          fr: "Bienvenue sur votre panneau d'administration",
        })}
        description={t({
          en: "To login and access the dashboard, please enter your username and password",
          fr: "Pour vous connecter et accéder au tableau de bord, veuillez saisir votre nom d'utilisateur et votre mot de passe",
        })}
      />
    </div>
    <form
      on:submit|preventDefault={handleLogin}
      class="mt-8 w-128 grid grid-cols-1"
    >
      <input
        type="text"
        placeholder={t({ en: "Username", fr: "Nom d'utilisateur" })}
        class="mb-4 shadow-sm"
        bind:value={username}
      />
      <input
        type="password"
        placeholder={t({ en: "Password", fr: "Mot de passe" })}
        class="mb-4 shadow-sm"
        bind:value={password}
      />
      {#if loading}
        <button disabled class="mb-4 btn btn-green animate-pulse">
          {t({ en: "Logging in...", fr: "Patientez..." })}
        </button>
      {:else}
        <button class="mb-4 btn btn-green">
          <i class="fas fa-arrow-right mr-3" />
          {t({ en: "Login", fr: "Se Connecter" })}
        </button>
      {/if}
    </form>
  </div>
</div>
